import { Component } from '@angular/core';

@Component({
  selector: 'abs-tagbadge',
  template: `<ng-content></ng-content>

`,
  styles: [`:host ::ng-deep .tagbadge{background-color:#f2f2f2;-webkit-transition:all .3s ease-out;transition:all .3s ease-out;margin:3px 5px 3px 0;padding:2px 15px;border-radius:6px;border:1px solid #c9c9c9;display:inline-block;font-size:14px}:host ::ng-deep .tagbadge i{color:#0574ac;font-size:14px;font-weight:700;margin-left:10px;cursor:pointer}`]
})
export class AbsTagbadgeComponent { }
